/* eslint-disable @typescript-eslint/no-explicit-any */
'use client';

import { EpRadioGroup } from '../../../../components/EpRadioGroup';
import { useTranslation as t } from '../../../../hooks/useTranslation';
import { memo } from 'react';
import { EpErrorMessage } from '../EpErrorMessage';
import { EpRadioButton } from '../EpRadioButton';
import { useTranslationStore } from '../../../../stores';
import { useFormContext } from 'react-hook-form';

type QuestionsAnswersProps = {
  questionId: number;
  questionDescription: string;
  required: boolean;
  maxLength: number;
  questionReferLibraryId: number;
  questionTypeId: number;
  questionsLibrary: boolean;
  questionCategoryIncident: number;
  order: number;
  answerRequiredId: number | null;
  questionRequiredId: number | null;
  answers?: {
    answerId: number;
    answerDescription: string;
  }[];
};

const EpQuestionRadio = ({
  QuestionsAnswers,
  index,
}: {
  QuestionsAnswers: QuestionsAnswersProps;
  index: number;
}) => {
  const { translations } = useTranslationStore();
  const controller = `questions.${index}`;
  const { formState: { errors } } = useFormContext();

  return (
    <>
      <EpRadioGroup legend={`${QuestionsAnswers.questionDescription} ${QuestionsAnswers.required ? '*' : ''}`}>
        {QuestionsAnswers.answers?.map((answer) => (
          <EpRadioButton
            key={answer.answerId}
            radioId={`EpRadio__${answer?.answerId}`}
            radioValue={answer.answerId.toString()}
            radioName={controller}
            radioLabel={t(translations['global'], answer.answerDescription)}
            required={QuestionsAnswers.required || !!QuestionsAnswers?.questionRequiredId}
            radioWithError={!!(errors['questions'] as any)?.[index]}
          />
        ))}
      </EpRadioGroup>
      <EpErrorMessage inputName={controller} />
    </>
  );
};

export default memo(EpQuestionRadio);
